import React from 'react';

import { HeartFilled } from '@ant-design/icons';
import { Alert, Button } from 'antd';

type SolidaritySquadAlertProps = {
  onBtnClick: () => void;
};

function SolidaritySquadAlert({ onBtnClick }: SolidaritySquadAlertProps) {
  return (
    <Alert
      type='info'
      className='max-sm:flex-col max-sm:items-center'
      message={
        <>
          Colabore para transformar vidas e a comunidade por meio da educação, qualificação profissional e
          empreendedorismo.{' '}
          <a href='https://www.projetoelevar.org.br/' target='_blank' rel='noopener noreferrer'>
            Clique aqui para saber mais.
          </a>
        </>
      }
      action={
        <Button
          icon={<HeartFilled />}
          block
          onClick={onBtnClick}
          className='shrink-0 max-sm:m-0 max-sm:w-full max-sm:p-0'
        >
          Quero colaborar
        </Button>
      }
    />
  );
}

export { SolidaritySquadAlert };
